import { createFileRoute } from '@tanstack/react-router';

import { QuickBooksCustomerMapping } from '../modules/QuickBooksCustomerMapping';

export const Route = createFileRoute('/quickbooks-customer-mapping')({
  component: RouteComponent,
  head: () => {
    return {
      meta: [{ title: 'QuickBooks Customer Mapping' }],
    };
  },
});

function RouteComponent() {
  return <QuickBooksCustomerMapping />;
}
